module.exports = __webpack_public_path__ + "media/images/icon_comment-9c78fd50c5cf114eb0d7690c90cb43cc.svg";